import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectAPIParams, selectButtonDefaults } from '../../../store/site'
import { withRouter } from 'react-router'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Section from '../../ui/Section'
import PageSearch from 'supporticon/components/page-search'
import SupporterSearchContainer from './SupporterSearchContainer'

const SupporterSearch = ({
  apiParams,
  backgroundImage,
  background,
  buttonBackground,
  buttonForeground,
  buttonProps,
  campaign,
  charity,
  event,
  foreground,
  label,
  modal,
  placeholder,
  router,
  size,
  spacing,
  styles,
  subtitle,
  type
}) => (
  <SupporterSearchContainer
    modal={modal}
    router={router}>
    <Section
      backgroundImage={backgroundImage}
      background={background}
      foreground={foreground}
      size={size}
      spacing={spacing}>
      <PageSearch
        campaign={campaign || apiParams.campaign}
        charity={charity || apiParams.charity}
        event={event || apiParams.event}
        subtitle={subtitle}
        type={type || 'individual'}
        button={{
          ...buttonProps,
          background: buttonBackground,
          foreground: buttonForeground
        }}
        searchForm={{
          expanded: true,
          placeholder: placeholder || 'Find a fundraiser',
          styles: styles.searchForm,
          title: label || 'Looking for someone?'
        }}
        searchResults={{
          styles: styles.results
        }}
        searchResult={{
          button: {
            ...buttonProps,
            background: buttonBackground,
            foreground: buttonForeground
          },
          styles: styles.result
        }}
      />
    </Section>
  </SupporterSearchContainer>
)

const mapState = (state) => ({
  buttonProps: selectButtonDefaults(state),
  ...selectAPIParams(state)
})

export default compose(
  withRouter,
  connect(mapState),
  withStyles(styles)
)(SupporterSearch)



// WEBPACK FOOTER //
// ./components/slices/SupporterSearch/index.js